export type AppType = 'admin' | 'website';

/**
 * Detecta dinamicamente se a instância atual deve se comportar como
 * o Website Institucional ou como o Painel Administrativo.
 */
export function getAppType(): AppType {
  const hostname = window.location.hostname;
  const port = window.location.port;

  // 1. Detecção em Produção baseada no hostname
  if (hostname === 'gspassessoria.com.br' || hostname === 'www.gspassessoria.com.br') {
    return 'website';
  }
  if (hostname === 'app.gspassessoria.com.br') {
    return 'admin';
  }

  // 2. Detecção Local baseada em variáveis de ambiente
  const envType = import.meta.env.VITE_APP_TYPE;
  if (envType === 'website') {return 'website';}
  if (envType === 'admin') {return 'admin';}

  // 3. Detecção Local baseada na porta
  if (port === '3672') {
    return 'website';
  }
  if (port === '3673') {
    return 'admin';
  }

  // Fallback padrão
  return 'admin';
}

/**
 * Retorna a URL completa para o Website Institucional Público
 */
export function getPublicWebsiteUrl(path: string = ''): string {
  const hostname = window.location.hostname;

  // Se estiver no domínio de produção do admin
  if (hostname === 'app.gspassessoria.com.br') {
    return `https://gspassessoria.com.br${path}`;
  }

  // Se estiver no localhost, app.localhost, ou rede local
  const isLocal = hostname === 'localhost' || hostname === 'app.localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.');
  if (isLocal) {
    return `http://localhost:3672${path}`;
  }

  // Fallback retirando o subdomínio 'app.' do host atual
  return `${window.location.protocol}//${hostname.replace('app.', '')}${path}`;
}

/**
 * Retorna a URL completa para o Painel Administrativo
 */
export function getAdminPanelUrl(path: string = ''): string {
  const hostname = window.location.hostname;

  // Se estiver no domínio de produção do website
  if (hostname === 'gspassessoria.com.br' || hostname === 'www.gspassessoria.com.br') {
    return `https://app.gspassessoria.com.br${path}`;
  }

  // Se estiver no localhost ou rede local
  const isLocal = hostname === 'localhost' || hostname === 'app.localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.');
  if (isLocal) {
    return `http://app.localhost:3673${path}`;
  }

  // Fallback adicionando o subdomínio 'app.'
  const cleanHost = hostname.replace('www.', '');
  return `${window.location.protocol}//app.${cleanHost}${path}`;
}
